import(/* webpackMode: "eager" */ "/tmp/8de6e09203c6a52/app/[locale]/error.tsx");
